// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3CRCM","savePackageButton":"ClientWallet_savePackageButton__ZvaBL"};